/** Sidebar section roots. Not WebDAV paths. */
export const NEXTCLOUD_SHARED_IN = 'nc-shares:in'
export const NEXTCLOUD_SHARES_OUT = 'nc-shares:out'

export function nextcloudShareList(path: string): 'in' | 'out' | null {
  if (path === NEXTCLOUD_SHARED_IN) return 'in'
  if (path === NEXTCLOUD_SHARES_OUT) return 'out'
  return null
}

export function nextcloudParentPath(path: string): string {
  const parts = path.split('/').filter(Boolean)
  parts.pop()
  return parts.length ? `/${parts.join('/')}` : '/'
}

export function nextcloudPathContains(folderPath: string, selectedPath: string | null): boolean {
  if (!selectedPath || selectedPath === folderPath) return false
  const prefix = folderPath === '/' ? '/' : `${folderPath}/`
  return selectedPath.startsWith(prefix)
}
